export enum EstadoFactura {
  PENDIENTE = 'Pendiente',
  ENVIADA = 'Enviada',
  APROBADA = 'Aprobada',
  RECHAZADA = 'Rechazada',
  CANCELADA = 'Cancelada',
}
